import React, { useContext } from 'react';
import classNames from 'classnames';
import { BrokerContext, LocaleContext } from '@qover/contexts';
import { FormattedMarkdown } from '@qover/react-intl';
import { CountrySelect } from '../topbar';
// @ts-ignore
import { ThemeContext } from '@qover/styles';
import { Trans } from '@lingui/react';
import { FooterContainer } from './footer.styles';
// @ts-ignore
import LogoAmex from './logo-american-express.svg';
// @ts-ignore
import logoBancontact from './logo-bancontact.svg';
// @ts-ignore
import logoMastercard from './logo-mastercard.svg';
// @ts-ignore
import logoVisa from './logo-visa.svg';

type FooterBaseProps = {
  showBottomNav?: boolean;
};
type FooterCountriesProps = FooterBaseProps & {
  flowStartUrl: string;
  updateDraftCountry?: (locale: string) => Promise<any>;
  showCountrySelectorModal?: boolean;
};

type FooterProps = FooterBaseProps | FooterCountriesProps;

export function Footer(props: FooterProps) {
  const { showBottomNav } = props;
  const { country } = useContext(LocaleContext);
  const broker = useContext(BrokerContext);
  const theme = useContext<any>(ThemeContext);
  const {
    flowStartUrl,
    updateDraftCountry,
    showCountrySelectorModal,
  } = props as FooterCountriesProps;

  const partnerType = theme?.featureToggles?.partnerType;

  return (
    <FooterContainer
      id="footer-container"
      className={classNames({ showBottomNav })}
    >
      <div className="language">
        <div style={{ marginBottom: '12px' }}>
          {theme?.featureToggles?.showPaymentOptionsInFooter && (
            <>
              <Trans id="general.securePayment" />
              <img src={logoVisa} />
              <img src={logoMastercard} />
              <img src={LogoAmex} />
              {country === 'BE' && <img src={logoBancontact} />}
            </>
          )}
        </div>
        <CountrySelect
          flowStartUrl={flowStartUrl}
          updateDraftCountry={updateDraftCountry}
          showCountrySelectorModal={showCountrySelectorModal}
        />
      </div>

      {partnerType === 'broker' && (
        <FormattedMarkdown
          id="general.brokerFooter"
          values={{
            legalName: broker?.informations?.general?.legalName,
            legalAddress: broker?.informations?.general?.operatingAddress,
            TVA: broker?.informations?.general?.tva,
            regulator: broker?.informations?.general?.regulatorReference,
            privacy:
              broker?.informations?.links?.privacy ??
              'https://www.qover.com/terms-and-policies#parentVerticalTab4',
            mifid: broker?.informations?.optionnalLinks?.[0]?.href ?? '#',
            legal: broker?.informations?.links?.generalInformation ?? '#',
          }}
        />
      )}
      <FormattedMarkdown
        id="general.qoverFooter"
        values={{ year: new Date().getFullYear() }}
      />
    </FooterContainer>
  );
}
